import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  Button,
  Grid,
  Typography,
  Tooltip,
  Divider,
} from '@material-ui/core';
import { DownloadIcon, SyncIcon } from 'components/Icons';

import trigger from 'utils/DownloadTrigger';
import useStyle from './style';
import { DocumentoResponse } from 'api/Associado/documentos';
import { documentoActionDownload } from 'store/modules/AssembleiasAssociadoActions';

interface Props extends DocumentoResponse {
  idEvento: number;
}

export default function Documento({
  codigo,
  nome,
  descricao,
  tipoDocumento,
}: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [isDownloading, setDownloading] = useState<boolean>(false);

  const downloadDocumento = useCallback(() => {
    setDownloading(true);
    dispatch(
      documentoActionDownload(
        codigo,
        (arrayBuffer: ArrayBuffer) => {
          setDownloading(false);
          trigger(nome, arrayBuffer);
        },
        () => {
          setDownloading(false);
        }
      )
    );
  }, [dispatch, codigo, nome]);
  
  return (
    <Grid container xs={12} className={classes.container}>
      <Grid item xs={10} className={classes.documentName}>
        <Typography>
          <strong>{tipoDocumento}</strong>
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Tooltip title={t('EditarDocumentosModal.tooltips.download') as string}>
          <Button
            variant="text"
            color="primary"
            endIcon={isDownloading ? <SyncIcon animated /> : <DownloadIcon />}
            onClick={downloadDocumento}
          >
            {t('EditarDocumentosModalAssociado.buttonDownload')}
          </Button>
        </Tooltip>
      </Grid>

      <Grid item xs={12} className={classes.documentName}>
        <Typography component="h2" className={classes.tagline} >
        <strong>{nome}</strong>
        </Typography>
      </Grid>

      <Grid item xs={12} className={classes.documentDescription}>
        <Typography variant="subtitle1" component={"p"}>
          {descricao}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.containerDivider}>
        <Divider />
      </Grid>
    </Grid>
  );
}
